module.exports = __webpack_public_path__ + "static/media/Soham_Naigaonkar.f2fb82b0.jpg";